import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CadastroDeAlcadasAdd({ setOption }) {
  return (
    <div>
      <ContainerSection>
        <h3>Principal</h3>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Código" id="Codigo" widthPercentage="100%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Descrição" id="Descricao" widthPercentage="100%" />
          </WrapperInputsNewSystem>
          <p>Valor</p>
          <WrapperInputsNewSystem>
            <InputText title="DE" id="de" widthPercentage="45%" />
            <InputText title="ATÉ" id="ate" widthPercentage="45%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="Usuário" id="Usuario" optionsArray={['']} widthPercentage="45%" />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="success">Confirmar</button>
            <button className="error" onClick={() => setOption('search')}>
              Retornar
            </button>
          </ButtonsGeneric>
        </div>
      </ContainerSection>
    </div>
  );
}
